var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66634 0.166992C2.12467 0.166992 2.49967 0.541992 2.49967 1.00033V11.0003C2.49967 11.4587 2.12467 11.8337 1.66634 11.8337C1.20801 11.8337 0.833008 11.4587 0.833008 11.0003V1.00033C0.833008 0.541992 1.20801 0.166992 1.66634 0.166992ZM4.99967 0.166992C5.45801 0.166992 5.83301 0.541992 5.83301 1.00033V11.0003C5.83301 11.4587 5.45801 11.8337 4.99967 11.8337C4.54134 11.8337 4.16634 11.4587 4.16634 11.0003V1.00033C4.16634 0.541992 4.54134 0.166992 4.99967 0.166992ZM18.333 0.166992H8.33301C7.87467 0.166992 7.49967 0.541992 7.49967 1.00033V11.0003C7.49967 11.4587 7.87467 11.8337 8.33301 11.8337H18.333C18.7913 11.8337 19.1663 11.4587 19.1663 11.0003V1.00033C19.1663 0.541992 18.7913 0.166992 18.333 0.166992ZM9.69967 9.49199L10.9247 7.94199C11.0913 7.73366 11.3997 7.73366 11.5747 7.93366L12.7413 9.33366L14.4913 7.07533C14.658 6.85866 14.983 6.85866 15.1497 7.07533L16.9913 9.49199C17.1997 9.76699 17.008 10.1587 16.658 10.1587H10.0247C9.68301 10.167 9.48301 9.76699 9.69967 9.49199Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.79cd2112.svg";
export { ForwardRef as ReactComponent };